import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import Intersect from 'vuetify/lib/directives/intersect';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VAutocomplete, {
    staticClass: "input-with-add-button",
    attrs: {
      "value": _vm.value,
      "items": _vm.selectOptions,
      "label": _vm.label,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "color": _vm.color,
      "loading": _vm.isLoadingOptions,
      "diabled": _vm.isLoadingOptions,
      "search-input": _vm.searchInputSync,
      "dense": _vm.dense,
      "hide-details": "",
      "clearable": "",
      "data-cy": "autocomplete_value"
    },
    on: {
      "update:searchInput": function ($event) {
        _vm.searchInputSync = $event;
      },
      "update:search-input": [function ($event) {
        _vm.searchInputSync = $event;
      }, function ($event) {
        return _vm.$emit('search-input', $event);
      }],
      "input": function ($event) {
        return _vm.$emit('input', $event);
      }
    },
    scopedSlots: _vm._u([{
      key: "no-data",
      fn: function () {
        return [_c(VListItem, [_c(VListItemContent, [_c(VListItemTitle, [_vm._v("\n          " + _vm._s(_vm.$i18n_t('Core.MultiSearch.noData.options')) + "\n        ")])], 1)], 1)];
      },
      proxy: true
    }, {
      key: "append-item",
      fn: function () {
        return [_vm.canLoadMore ? _c('div', {
          directives: [{
            def: Intersect,
            name: "intersect",
            rawName: "v-intersect",
            value: _vm.onIntersect,
            expression: "onIntersect"
          }],
          staticClass: "pa-2 text-center"
        }, [_vm.isLoadingMore ? _c(VProgressCircular, {
          attrs: {
            "indeterminate": "",
            "size": "24",
            "color": _vm.color
          }
        }) : _c('span', {
          staticClass: "text-caption"
        }, [_vm._v(_vm._s(_vm.$i18n_t('Core.MultiSearch.actions.loadMore')))])], 1) : _vm._e()];
      },
      proxy: true
    }, {
      key: "append-outer",
      fn: function () {
        return [_c('core-button', {
          staticClass: "rule-add-button",
          attrs: {
            "color": _vm.color,
            "disabled": !_vm.canAddRule,
            "prepend-icon": "fa-plus",
            "data-cy": "button_add_rule"
          },
          on: {
            "click": function ($event) {
              return _vm.$emit('add-rule');
            }
          }
        })];
      },
      proxy: true
    }])
  });
};
var staticRenderFns = [];
export { render, staticRenderFns };